import { useQuery } from "@tanstack/react-query";
import { getJSON } from "@/utils/fetcher";

interface DuneData {
  unique_depositors: number;
  amount_locked: number;
  supply_locked: number;
}

export function useDuneSupplyLocked() {
  const { data, error, isLoading } = useQuery({
    queryKey: ["dune", "supply-locked"],
    queryFn: () => getJSON<DuneData>("/api/earn/dune-supply-locked"),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
  const formattedSupplyLocked = data?.supply_locked
    ? `${Number(data.supply_locked).toFixed(2)}%`
    : null;
  return {
    supplyLocked: formattedSupplyLocked,
    uniqueDepositors: data?.unique_depositors ?? null,
    isLoading,
    error,
  };
}
